import { defineComponent as v, ref as w, computed as s, toRef as z, resolveComponent as $, openBlock as d, createBlock as k, createSlots as O, withCtx as u, createElementVNode as y, normalizeClass as r, createElementBlock as b, renderSlot as a, createCommentVNode as g } from "vue";
import { usePopoverState as N } from "@onereach/ui-components-common/hooks";
import { R as o, O as P } from "./OrResizeablePanel-DuGgwmhB.mjs";
import { _ as R } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const C = [
  // Layout
  "layout-column grow",
  // Overflow
  "overflow-hidden"
], B = [
  // Layout
  "shrink-0",
  // Overflow
  "overflow-hidden",
  // Typography
  "typography-headline-2 truncate"
], L = {
  [o.L]: [
    // Box
    "px-lg",
    "py-lg"
  ],
  [o.M]: [
    // Box
    "px-md",
    "py-md"
  ],
  [o.S]: [
    // Box
    "px-sm",
    "py-sm"
  ],
  [o.None]: []
}, M = [
  // Layout
  "grow",
  // Overflow
  "overflow-auto"
], W = {
  [o.L]: [
    // Box
    "px-lg",
    "py-lg"
  ],
  [o.M]: [
    // Box
    "px-md",
    "py-md"
  ],
  [o.S]: [
    // Box
    "px-sm",
    "py-sm"
  ],
  [o.None]: []
}, E = [
  // Layout
  "shrink-0",
  // Overflow
  "overflow-hidden",
  // Theme
  "theme-border-outline-variant border-t-1",
  "dark:theme-border-outline-variant-dark"
], F = {
  [o.L]: [
    // Box
    "px-lg",
    "py-lg"
  ],
  [o.M]: [
    // Box
    "px-md",
    "py-md"
  ],
  [o.S]: [
    // Box
    "px-sm",
    "py-sm"
  ],
  [o.None]: []
}, H = v({
  name: "OrSidebar",
  components: {
    OrResizeablePanel: P
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !0
    },
    width: {
      type: Number,
      default: 320
    },
    minWidth: {
      type: Number,
      default: void 0
    },
    maxWidth: {
      type: Number,
      default: void 0
    },
    padding: {
      type: String,
      default: () => o.M
    },
    placement: {
      type: String,
      default: void 0
    },
    resizeable: {
      type: Boolean,
      default: void 0
    },
    collapsible: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:state",
    "open",
    "close",
    "resize"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, t) {
    const i = w(), p = s(() => [
      "or-sidebar-v3",
      ...C
    ]), m = s(() => [
      ...B,
      ...L[e.padding]
    ]), f = s(() => [
      ...M,
      ...W[e.padding]
    ]), l = s(() => [
      ...E,
      ...F[e.padding]
    ]), { state: n, open: h, close: S, toggle: c } = N(z(e, "isOpen"), t.emit);
    return {
      root: i,
      rootStyles: p,
      headerStyles: m,
      contentStyles: f,
      footerStyles: l,
      state: n,
      open: h,
      close: S,
      toggle: c
    };
  }
});
function V(e, t, i, p, m, f) {
  const l = $("OrResizeablePanel");
  return d(), k(l, {
    "is-open": e.state === "open",
    width: e.width,
    "min-width": e.minWidth,
    "max-width": e.maxWidth,
    padding: "none",
    placement: e.placement,
    resizeable: e.resizeable,
    collapsible: e.collapsible,
    "onUpdate:state": t[0] || (t[0] = (n) => n === "open" ? e.open() : e.close()),
    onResize: t[1] || (t[1] = (n) => e.$emit("resize", n))
  }, O({
    default: u(() => [
      y("div", {
        ref: "root",
        class: r(e.rootStyles)
      }, [
        e.$slots.header ? (d(), b("header", {
          key: 0,
          class: r(e.headerStyles)
        }, [
          a(e.$slots, "header")
        ], 2)) : g("", !0),
        y("div", {
          class: r(e.contentStyles)
        }, [
          a(e.$slots, "default")
        ], 2),
        e.$slots.footer ? (d(), b("footer", {
          key: 1,
          class: r(e.footerStyles)
        }, [
          a(e.$slots, "footer")
        ], 2)) : g("", !0)
      ], 2)
    ]),
    _: 2
  }, [
    e.$slots.toolbar ? {
      name: "toolbar",
      fn: u(() => [
        a(e.$slots, "toolbar")
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["is-open", "width", "min-width", "max-width", "placement", "resizeable", "collapsible"]);
}
const G = /* @__PURE__ */ R(H, [["render", V]]);
var U = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(U || {});
export {
  G as O,
  U as S
};
//# sourceMappingURL=props-BxqD8LGb.mjs.map
